// extracted by mini-css-extract-plugin
module.exports = {"pagesSidebar":"_1-c7K","collapsedPagesSidebar":"_18mia","sidebarHeader":"_2Ef6S","sidebarList":"_1fsc5","hiddenPagesSidebar":"_1OK_W"};